import { Button, Divider, Flex, LoadingOverlay, Paper, Text } from "@mantine/core";
import IconDeviceFloppy from "@tabler/icons-react/dist/esm/icons/IconDeviceFloppy.mjs";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import EmailNotificationsSection from "./components/EmailNotificationsSection";
import {
  useEmailNotificationsQuery,
  useSaveEmailNotificationsMutation,
} from "./useEmailNotifications.logic";

const defaultValues = { notifications: [] };

const EmailNotifications = () => {
  const { data: notificationsData, isLoading } = useEmailNotificationsQuery();
  const saveMutation = useSaveEmailNotificationsMutation();

  const {
    control,
    handleSubmit,
    reset,
    formState: { dirtyFields, isDirty },
  } = useForm({ defaultValues });

  useEffect(() => {
    if (!notificationsData) return;
    reset({
      notifications: notificationsData.map((n) => ({
        emailType: n.emailType,
        enabled: !!n.enabled,
        label: n.label,
      })),
    });
  }, [notificationsData, reset]);

  const onSubmit = (values) => {
    const changed = (values.notifications || [])
      .filter((_, i) => dirtyFields.notifications?.[i]?.enabled)
      .map((n) => ({ emailType: n.emailType, enabled: n.enabled }));
    if (!changed.length) return;

    saveMutation.mutate(changed, {
      onSuccess: () => reset(values),
    });
  };

  return (
    <Paper pos="relative" withBorder radius="md" style={{ overflow: "hidden" }}>
      <LoadingOverlay visible={isLoading || saveMutation.isPending} overlayBlur={2} />
      <Flex justify="space-between" align="center" p="sm">
        <Text size="md">
          Email notifications
        </Text>
        <Button
          leftSection={<IconDeviceFloppy />}
          onClick={handleSubmit(onSubmit)}
          size="sm"
          disabled={!isDirty}
          loading={saveMutation.isPending}
        >
          SAVE
        </Button>
      </Flex>
      <Divider color="secondary.1" />
      <Paper bg="secondary.0" p="md" radius={0}>
        <EmailNotificationsSection control={control} />
      </Paper>
    </Paper>
  );
};

export default EmailNotifications;
